import { CandelabraFireIcon } from './CandelabraFireIcon';

/**
 * author: Colton Wiscombe
 * id CF2B4CE1-69FF-472B-BE94-620D71F5A42F
 * name candelabra-fire
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/candelabra-fire.svg
 * tags
 * - Home Automation 
 * - Holiday 
 */
export const CandelabraFlameIcon = CandelabraFireIcon;
export default CandelabraFlameIcon